<template>
  <div v-if="groupId && groupId > 0" class="groupMembersList"  >
    <v-container
      class="ma-0 pa-0"
      wrap
      grid-list-md
      align-left
      no-gutter
      fill-height
    >
      <v-layout class="mb-2" row wrap>
        <v-flex class="" xs3>

        </v-flex>
        <v-flex class="" xs6>
          <p class="text-xs-center text-center pt-0">
            <strong v-if="loadingMembers">
              <span>Fetching Members</span>
              <br/>
              <v-progress-linear
                indeterminate
                rounded
                height="2"
              ></v-progress-linear>
            </strong>
            <strong v-else>{{ memberCount }}
              <span v-if="memberCount == 1">Member</span>
              <span v-else>Members</span>
            </strong>
          </p>
        </v-flex>
        <v-flex class="" xs3 text-right>
          <router-link
            class="manageMembers"
            :to="'/group/members/' + groupId"
            v-if="groupId && canManage"
            >Manage</router-link
          >
        </v-flex>
      </v-layout>
    </v-container>

    <v-layout class="mb-2" wrap align-left ref="list">
      <!-- <h1>{{ width }} => {{ cols }}</h1> -->
      <v-data-iterator
        class="text-xs-left memberIterator"
        :class="cols < 5 ? 'hidePages' : ''"
        :items="sortedUsers"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :hide-actions="hideActions"
        content-tag="v-layout"
        full-width
      >
      <template v-slot:no-data>
        <span v-if="loadingMembers"><!-- Data is loading. --></span>
        <span v-else>No members available</span>
      </template>
      <template v-slot:item="props">
        <span class="groupUserWrapper" :ref="'member' + props.index">
        <v-badge
          right
          bottom
          overlap
          color="#F8C822"
          v-if="props.item.isOwner || props.item.role == 'admin'"
        >
          <template v-slot:badge>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <i
                  class="fas fa-user-check"
                  v-on="on"
                  v-if="props.item.isOwner"
                ></i
                ><i class="fas fa-check" v-on="on" v-else></i>
              </template>
              <span v-if="props.item.isOwner">Group Owner</span
              ><span v-else>Group Administrator</span> </v-tooltip
            >
          </template>
          <AmazeAvatar
            :user="props.item"
            :key="props.item.id"
            :size="avatarWidth+'px'"
            spacing="mr-1 mb-1"
          ></AmazeAvatar>
        </v-badge>
        <AmazeAvatar
          v-else
          :user="props.item"
          :key="props.item.id"
          :size="avatarWidth+'px'"
          spacing="mr-1 mb-1"
        ></AmazeAvatar>
      </span>
      </template>
      </v-data-iterator>
    </v-layout>

    <v-container
      class="ma-0 pa-0"
      wrap
      grid-list-md
      align-left
      no-gutter
      fill-height
    >
      <v-layout class="" row wrap>
        <v-flex class="" xs3 md2></v-flex>
        <v-flex class="" xs3 md2></v-flex>
        <v-flex class="" xs6 md8 text-right>
          <v-btn
            flat
            class="exportMembers text-bold"
            @click.prevent="getGroupMemberCSVDownload()"
            title="Export Member Data to CSV"
            v-if="groupId && canManage && this.$auth.check(['uber_admin'])"
            ><i class="fa fa-download" aria-hidden="true"></i> <strong class="ml-2">Member Data
            </strong></v-btn
          >
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<style scoped lang="scss">
@import "src/styles/variables.scss";
.manageMembers {
  font-weight: bold;
}

::v-deep {
  .memberIterator {
    width: 100%;
    &.hidePages {
      button {
        margin:0;
        padding:0;
        * {
          margin:0;
          padding:0;
          padding-left: 4px;
        }
      }
      .v-data-iterator__actions__pagination {
        display: block;
        margin-left:0;
        margin:0;
        padding:0;
      }
    }
  }

  .v-data-iterator__actions__pagination {
    white-space: nowrap;
    margin-left: 0;
  }
  .v-data-iterator__actions {
    justify-content: left;
  }
}

</style>

<script>
import GroupService from "@/services/GroupService";
import AmazeAvatar from "@/components/Widgets/AmazeAvatar";
import _ from "lodash";
import VuePapaParse from 'vue-papa-parse';
import Vue from 'vue';
Vue.use(VuePapaParse);

export default {
  components: { AmazeAvatar },
  props: ["groupId", "canManage", "ownerId", "group"],
  data() {
    return {
      // group: {},
      member_count: 0,
      members: null,
      loadingMembers: true,
      pagination: {},
      width: 0,
      cols: 0,
      avatarWidth: 38,
      margin: 4,
      rows: 4,
      rowsPerPageItems: [18]
    };
  },
  computed: {
    hideActions() {
      return this.memberCount <= this.cols * this.rows;
    },
    memberCount() {
      if (typeof this.members !== "undefined" && this.members) {
        return this.members.length || this.member_count;
      } else {
        return 0;
      }
    },
    sortedUsers() {
      return this.members
        ? this.members.concat().sort((a, b) => {
          const result =
              a["last_name"] == b["last_name"]
                ? 0
                : a["last_name"] > b["last_name"]
                  ? 1
                  : -1;
          return result !== 0
            ? result
            : a["first_name"] == b["first_name"]
              ? 0
              : a["first_name"] > b["first_name"]
                ? 1
                : -1;
        })
        : [];
    }
  },
  methods: {
    updateWidth() {
      this.width = this.$refs.list ? this.$refs.list.getBoundingClientRect().width : 0;
      this.userWidth = this.avatarWidth + this.margin;
      this.cols = Math.floor(this.width / this.userWidth);
      this.pagination.rowsPerPage = this.cols * this.rows;
      this.rowsPerPageItems = [this.pagination.rowsPerPage];
    },
    reset() {
      this.group = {};
      this.member_count = 0;
      this.members = null;
    },
    getGroupMemberCSVDownload() {
      // Let's disable for non-admin users.
      // Emails are still hidden either way (via the API).
      // And names are already fully public, so no concern there.
      // We just don't want to give non-admins the ability to download the data.
      if (!this.canManage || !this.$auth.check(['uber_admin'])) {
        return false;
      }
      // get today's date as a human readable string in YYMMDD format.
      const today = new Date().toISOString().slice(0, 10).replace(/-/g, "");
      // Use papaparse to create a csv download of the group members.
      // https://www.papaparse.com/docs#json-to-csv
      this.$papa.download(this.$papa.unparse(this.members, { 'columns': ['first_name', 'last_name', 'display_name', 'email'] }), today + '_members_' + this.group.name);
    },
    getGroupMembers: _.debounce(function(groupId) {
      this.loadingMembers = true;
      if (typeof groupId === 'undefined' || isNaN(groupId)) {
        return false;
      }

      return GroupService.getGroupMembers(groupId)
        .then(
          response => {
            // get body data
            this.members = response;
          },
          response => {
            console.error("[error] getGroupMembers");
          }
        )
        .finally(() => {
          this.loadingMembers = false;
        });
    }, 100)
  },
  watch: {
    "members": {
      deep: true,
      handler(newval, oldval) {
        this.$nextTick(function () {
          this.updateWidth();
        });
      }

    }
  },
  mounted() {
    this.updateWidth();
  },
  created() {
    window.addEventListener("resize", this.updateWidth);
    this.getGroupMembers(this.groupId);
  },
  destroyed() {
    window.removeEventListener("resize", this.updateWidth);
  }
};
</script>
